import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { Attestation } from "../../../service/global.service";
import { DatePipe } from "@angular/common";
import { Backend } from 'src/app/backend-interface/backend';
import { NgbModal, NgbModalConfig, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from 'src/app/service/translation.service';
import { HasRolesDirective } from 'keycloak-angular';
import { CommonsModalPartComponent } from '../../commons-modal-part/commons-modal-part';

@Component({
  selector: 'details-attestations-without-score',
  templateUrl: './details-attestations-without-score.component.html',
  styleUrls: ['./details-attestations-without-score.component.scss'],
  standalone: true,
  providers: [NgbModalConfig, NgbModal, DatePipe, TranslationService],
  imports: [TranslateModule, HasRolesDirective, NgbTooltipModule, CommonsModalPartComponent]
})
export class DetailsAttestationsWithoutScoreComponent {
  @Input() listeprobes?: string[];
  @Input() objetCourant?: Attestation;
  @Input() attestation?: boolean;
  @Output() filtreApp = new EventEmitter<string>();
  @Output() filtreID = new EventEmitter<string>();

  readonly translationService = inject(TranslationService);

  listDP = signal(true);
  dpdetails = signal(false);
  metadata = signal<Map<any, any> | undefined>(undefined);

  ldetectorsprobes = signal<Map<any, any> | undefined>(undefined);
  familleCourante = signal<string | undefined>(undefined);
  detailsprobestitle?: string;

  constructor(
    public datepipe: DatePipe,
    config: NgbModalConfig,
    private readonly modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  open({ content }: { content: any }) {
    this.modalService.open(content, { size: 'xl' });
  }

  getApp() {
    this.filtreApp.emit(this.objetCourant?.appInfo?.appName);
  }

  getID() {
    this.filtreID.emit(this.objetCourant?.appInfo?.appId);
  }

  getContrycode() {
    return this.objetCourant?.location?.countryCode || this.objetCourant?.location?.country;
  }

  getApptimeStamp() {
    if (this.objetCourant?.appInfo?.appInstallationTimestamp) {
      const date = new Date(this.objetCourant.appInfo.appInstallationTimestamp * 1000);
      return this.datepipe.transform(date, "dd/MM/yyyy");
    }
    return this.translationService.get('unknown-app-installation-date');
  }

  modelMarque() {
    const model = this.objetCourant?.deviceInfo?.model?.toLowerCase();
    if (!model) return this.translationService.get('unknown-model');
    const brands = [
      'google', 'samsung', 'asus', 'honor', 'huawei', 'vivo', 'xiaomi',
      'htc', 'oneplus', 'oppo', 'nokia', 'lg', 'sony'
    ];
    for (const brand of brands) {
      if (model.includes(brand)) return brand;
    }
    return this.translationService.get('unknown-model');
  }

  formatN(chaine: string | undefined, n: number) {
    return Backend.FORMAT.formatN(chaine, n);
  }

  formatVersion(chaine: string | undefined) {
    if (chaine && chaine.length > 7) {
      return chaine.slice(0, 7) + '...';
    }
    return chaine;
  }

  formatType(bwCompromiseType: any) {
    return bwCompromiseType
      ? bwCompromiseType.toLowerCase().replaceAll(/[\s\-_]|ko/g, '')
      : undefined;
  }

  formatKernelVersion() {
    let format = this.objetCourant?.deviceInfo?.kernelVersion;
    if (format) {
      for (const sep of ['/', '#', ':', '-']) {
        const idx = format.indexOf(sep);
        if (idx !== -1) format = format.slice(0, idx); 
      }
      format += '...';
    }
    return format;
  }

  getCity() {
    return this.objetCourant?.location?.city || this.translationService.get('unknown-location-city');
  }

  formatName(model: string | undefined) {
    return model
      ? model[0].toUpperCase() + model.slice(1)
      : this.translationService.get('unknown-device');
  }

  getlength(str: string | undefined) {
    return str ? str.length : 0;
  }

  attestationType() {
    return Object.prototype.toString.apply(this.objetCourant);
  }

  getAllProbesDetectors(family: string) {
    const res = new Map();
    const map = this.objetCourant?.probes;
    if (map) {
      for (const [key, value] of Object.entries(map)) {
        if (key.includes(family)) {
          res.set(key, value);
        }
      }
    }
    this.ldetectorsprobes.set(res);
  }

  setFamilyselected(noms: string) {
    this.familleCourante.set(noms);
  }

  formatTitlePDProbes() {
    const container = document.getElementById('modal-basic-title2');
    this.translationService.get('attestations-title-details').subscribe(detailsTitle => {
      let output = `${detailsTitle} ${this.detailsprobestitle?.toLowerCase()}`;
      const lang = this.translationService.getCurrentLang();
      if ((lang === "en" || lang === "fr")) {
        this.translationService.get('attestations-modal-title-lprobedetectors').subscribe(lprobe => {
          output = lang === "en"
            ? `${detailsTitle} <b>${this.familleCourante()}</b>${lprobe}`
            : `${detailsTitle} ${lprobe} <b>${this.familleCourante()}</b>`;
          if (container) container.innerHTML = output;
        });
        return;
      }
      if (container) container.innerHTML = output;
    });
  }

  async resetModal() {
    await new Promise(r => setTimeout(r, 500));
    this.listDP.set(false);
    this.dpdetails.set(false);
    this.metadata.set(undefined);
  }

  async backModal() {
    await new Promise(r => setTimeout(r, 200));
    if (this.dpdetails()) {
      this.listDP.set(true);
      this.dpdetails.set(false);
    }
    if (this.metadata()) {
      this.metadata.set(undefined);
    }
  }

  getMetaData() {
    if (this.objetCourant?.metadata && Object.entries(this.objetCourant.metadata).length > 0) {
      return new Map(Object.entries(this.objetCourant.metadata));
    }
    return undefined;
  }
}
